import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const SaveHypervergeDataApi = createAsyncThunk(
  'SaveHypervergeDataApi',
  async (apiPayload, { dispatch }) => {
    dispatch({ type: 'SaveHypervergeDataApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum, hyperVergeData } =
      apiPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerkyc/savehypervergedata',
      payload: {
        customerRefNum,
        hyperVergeData,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `SaveHypervergeDataApi Response: `, res);
        dispatch({
          type: 'SaveHypervergeDataApi/fulfilled',
          payload: res,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'SaveHypervergeDataApi/rejected', payload: err });
      },
    });
  }
);

export const SaveHypervergeDataApi_extrareducer = {
  [SaveHypervergeDataApi.pending]: (state, action) => {
    state.SaveHypervergeDataApiState.isLoading = true;
  },
  [SaveHypervergeDataApi.fulfilled]: (state, action) => {
    state.SaveHypervergeDataApiState.isLoading = false;
    state.SaveHypervergeDataApiState.isSuccess = true;
    state.SaveHypervergeDataApiState.isError = false;
    state.SaveHypervergeDataApiState.response = action.payload;
  },
  [SaveHypervergeDataApi.rejected]: (state, action) => {
    state.SaveHypervergeDataApiState.isLoading = false;
    state.SaveHypervergeDataApiState.isSuccess = false;
    state.SaveHypervergeDataApiState.isError = true;
    state.SaveHypervergeDataApiState.response = action.payload;
  },
};
